import * as tslib_1 from "tslib";
import { deepMixin, xml2json } from "@hpcc-js/util";
import { ESPConnection } from "../espConnection";
/*
    Response structures generated via:
    * http://192.168.3.22:8010/WsWorkunits/WUQuery?respjson_
    * http://json2ts.com/
*/
export var WUStateID;
(function (WUStateID) {
    WUStateID[WUStateID["Unknown"] = 0] = "Unknown";
    WUStateID[WUStateID["Compiled"] = 1] = "Compiled";
    WUStateID[WUStateID["Running"] = 2] = "Running";
    WUStateID[WUStateID["Completed"] = 3] = "Completed";
    WUStateID[WUStateID["Failed"] = 4] = "Failed";
    WUStateID[WUStateID["Archived"] = 5] = "Archived";
    WUStateID[WUStateID["Aborting"] = 6] = "Aborting";
    WUStateID[WUStateID["Aborted"] = 7] = "Aborted";
    WUStateID[WUStateID["Blocked"] = 8] = "Blocked";
    WUStateID[WUStateID["Submitted"] = 9] = "Submitted";
    WUStateID[WUStateID["Scheduled"] = 10] = "Scheduled";
    WUStateID[WUStateID["Compiling"] = 11] = "Compiling";
    WUStateID[WUStateID["Wait"] = 12] = "Wait";
    WUStateID[WUStateID["UploadingFiled"] = 13] = "UploadingFiled";
    WUStateID[WUStateID["DebugPaused"] = 14] = "DebugPaused";
    WUStateID[WUStateID["DebugRunning"] = 15] = "DebugRunning";
    WUStateID[WUStateID["Paused"] = 16] = "Paused";
    WUStateID[WUStateID["LAST"] = 17] = "LAST";
    WUStateID[WUStateID["NotFound"] = 999] = "NotFound";
})(WUStateID || (WUStateID = {}));
export var WUUpdate;
(function (WUUpdate) {
    var Action;
    (function (Action) {
        Action[Action["Unknown"] = 0] = "Unknown";
        Action[Action["Compile"] = 1] = "Compile";
        Action[Action["Check"] = 2] = "Check";
        Action[Action["Run"] = 3] = "Run";
        Action[Action["ExecuteExisting"] = 4] = "ExecuteExisting";
        Action[Action["Pause"] = 5] = "Pause";
        Action[Action["PauseNow"] = 6] = "PauseNow";
        Action[Action["Resume"] = 7] = "Resume";
        Action[Action["Debug"] = 8] = "Debug";
        Action[Action["__size"] = 9] = "__size";
    })(Action = WUUpdate.Action || (WUUpdate.Action = {}));
})(WUUpdate || (WUUpdate = {}));
export function isWUQueryECLWorkunit(_) {
    return _.TotalClusterTime !== undefined;
}
export function isWUInfoWorkunit(_) {
    return _.StateEx !== undefined;
}
var WorkunitsService = /** @class */ (function () {
    function WorkunitsService(optsConnection) {
        this._connection = new ESPConnection(optsConnection, "WsWorkunits", "1.68");
    }
    WorkunitsService.prototype.opts = function () {
        return this._connection.opts();
    };
    WorkunitsService.prototype.connection = function () {
        return this._connection;
    };
    WorkunitsService.prototype.WUQuery = function (request) {
        if (request === void 0) { request = {}; }
        return this._connection.send("WUQuery", request).then(function (response) {
            return deepMixin({ Workunits: { ECLWorkunit: [] } }, response);
        });
    };
    WorkunitsService.prototype.WUInfo = function (_request) {
        var request = tslib_1.__assign({ Wuid: "", TruncateEclTo64k: true, IncludeExceptions: false, IncludeGraphs: false, IncludeSourceFiles: false, IncludeResults: false, IncludeResultsViewNames: false, IncludeVariables: false, IncludeTimers: false, IncludeDebugValues: false, IncludeApplicationValues: false, IncludeWorkflows: false, IncludeXmlSchemas: false, IncludeResourceURLs: false, SuppressResultSchemas: true }, _request);
        return this._connection.send("WUInfo", request);
    };
    WorkunitsService.prototype.WUCreate = function () {
        return this._connection.send("WUCreate");
    };
    WorkunitsService.prototype.WUUpdate = function (request) {
        return this._connection.send("WUUpdate", request, "json", true);
    };
    WorkunitsService.prototype.WUSubmit = function (request) {
        return this._connection.send("WUSubmit", request);
    };
    WorkunitsService.prototype.WUResubmit = function (request) {
        this._connection.toESPStringArray(request, "Wuids");
        return this._connection.send("WUResubmit", request);
    };
    WorkunitsService.prototype.WUQueryDetails = function (request) {
        return this._connection.send("WUQueryDetails", request);
    };
    WorkunitsService.prototype.WUListQueries = function (request) {
        return this._connection.send("WUListQueries", request);
    };
    WorkunitsService.prototype.WUPushEvent = function (request) {
        return this._connection.send("WUPushEvent", request);
    };
    WorkunitsService.prototype.WUAction = function (request) {
        request.ActionType = request.WUActionType; //  v5.x compatibility
        return this._connection.send("WUAction", request);
    };
    WorkunitsService.prototype.WUGetZAPInfo = function (request) {
        return this._connection.send("WUGetZAPInfo", request);
    };
    WorkunitsService.prototype.WUShowScheduled = function (request) {
        return this._connection.send("WUShowScheduled", request);
    };
    WorkunitsService.prototype.WUQuerySetAliasAction = function (request) {
        return this._connection.send("WUQuerySetAliasAction", request);
    };
    WorkunitsService.prototype.WUQuerySetQueryAction = function (request) {
        return this._connection.send("WUQuerySetQueryAction", request);
    };
    WorkunitsService.prototype.WUPublishWorkunit = function (request) {
        return this._connection.send("WUPublishWorkunit", request);
    };
    WorkunitsService.prototype.WUGetGraph = function (request) {
        return this._connection.send("WUGetGraph", request);
    };
    WorkunitsService.prototype.WUResult = function (request) {
        return this._connection.send("WUResult", request);
    };
    WorkunitsService.prototype.WUQueryGetGraph = function (request) {
        return this._connection.send("WUQueryGetGraph", request);
    };
    WorkunitsService.prototype.WUFile = function (request) {
        return this._connection.send("WUFile", request, "text");
    };
    WorkunitsService.prototype.WUGetStats = function (request) {
        return this._connection.send("WUGetStats", request);
    };
    WorkunitsService.prototype.WUDetailsMeta = function (request) {
        if (!this._WUDetailsMetaPromise) {
            this._WUDetailsMetaPromise = this._connection.send("WUDetailsMeta", request);
        }
        return this._WUDetailsMetaPromise;
    };
    WorkunitsService.prototype.WUDetails = function (request) {
        return this._connection.send("WUDetails", request);
    };
    WorkunitsService.prototype.WUCDebug = function (request) {
        return this._connection.send("WUCDebug", request).then(function (response) {
            var retVal = xml2json(response.Result);
            var children = retVal.children();
            if (children.length) {
                return children[0];
            }
            return null;
        });
    };
    return WorkunitsService;
}());
export { WorkunitsService };
//# sourceMappingURL=wsWorkunits.js.map